<div class="wrapper flex gap-[20px] w-full">
  @if (currentIndex !== 0) {
    <div
      (click)="back()"
      [class.disabled]="currentIndex === 0"
      class="action-button menu-button"
      >
      <mat-icon [svgIcon]="'arrow'" class="menu"></mat-icon>
    </div>
  }
  @if (currentIndex === 0) {
    <div class="h-[44px] w-[44px]"></div>
  }
  <app-primary-button
    (handleClick)="next()"
    [isDisabled]="currentIndex === fields.length - 1"
    class="next-button"
    >
    Next
  </app-primary-button>
  <div
    [matMenuTriggerFor]="add"
   
    class="action-button add-button"
    >
    <mat-icon class="add" svgIcon="plus" />
  </div>

  <mat-menu #add="matMenu">
    @for (option of addMenuOptions; track option) {
      <button
        (click)="option.handler()"
        mat-menu-item
        >
        <div class="add-menu-item flex justify-start items-center">
          <div class="flex justify-center items-center h-[48px]">
            <mat-icon [svgIcon]="option.icon" class="menu-icon" />
          </div>
          <div class="menu-label">{{ option.label }}</div>
        </div>
      </button>
    }
  </mat-menu>
</div>
<input
  #fileInput
  (change)="onFileSelected($event)"
  accept=".png, .jpg, .jpeg, .mp4"
  class="hidden"
  multiple="multiple"
  type="file"
  />
